import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getRegion } from '../../../../../../utils/Region';
import { translate } from '../../../../utils/mundialUtils';
import './style.scss';
import { pushEvent } from 'containers/Player/utils/analytics';
import {
  events,
  Actions,
  category,
} from 'containers/MundialViews/utils/analytics';
import { useOpenPlayer } from '../../../../../../hooks/useOpenPlayer';
import { useNavigate } from 'react-router-dom';

const BracketActionButton = ({
  status,
  matchId,
  translations,
  defined,
  awayName,
  homeName,
}) => {
  const navigate = useNavigate();
  const { openPlayerWithTransaction } = useOpenPlayer();
  const qatarConfig =
    useSelector(state => state.metadata?.match_live_button) || null;

  const onClick = () => {
    pushEvent(
      events.CARDMATCH,
      category.MENU,
      Actions.MATCH,
      `${homeName?.toLowerCase()} vs ${awayName?.toLowerCase()}`,
    );
    if (status === 'COMPLETED' || status === 'SCHEDULED' || !enablePlay) {
      return navigate(`/${getRegion()}/vcard/match/${matchId}`);
    }

    if (status === 'IN_PROGRESS' && enablePlay) {
      const groupId =
        JSON.parse(qatarConfig)[getRegion()]?.group_id ||
        JSON.parse(qatarConfig).default?.group_id;

      openPlayerWithTransaction(groupId);
    }
  };

  const enablePlay = useMemo(
    () => {
      if (qatarConfig) {
        const enable =
          JSON.parse(qatarConfig)[getRegion()]?.enable ||
          JSON.parse(qatarConfig).default?.enable;
        return enable;
      }
      return false;
    },
    [qatarConfig],
  );

  if (status === 'SCHEDULED' && !defined) return null;

  return (
    <button
      className={`bracket-action-button ${status} ${status === 'IN_PROGRESS' &&
        !enablePlay &&
        'not-avalible'} ${defined && status === 'SCHEDULED' && 'def'}`}
      onClick={onClick}
    >
      <span className="bracket-action-button__text">
        {translate(
          status === 'IN_PROGRESS' && enablePlay
            ? 'matches_result_option_button_play'
            : 'matches_result_option_button_details',
          translations,
        )}
      </span>
    </button>
  );
};

export default BracketActionButton;
